var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"af-app af-login-widget"},[(_vm.showLoggedIn)?_c('LoggedIn'):_vm._e(),(_vm.showLoggedOut)?_c('LoggedOut'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }